// Decorative illustrations (public/illustrations, WebP with a transparent background). A missing file hides itself.

export const ILLUSTRATIONS = {
  overview: '/illustrations/overview.webp',
  shipments: '/illustrations/shipments.webp',
  /** a truck on the road (the same file as `shipments`, cached once): the truck card's picture until a vehicle has a photo */
  truck: '/illustrations/shipments.webp',
  cylinders: '/illustrations/cylinders.webp',
  /** one small cylinder (SVG, ~1 KB, cached once) beside every serial number: list rows, the cylinder header */
  cylinderThumb: '/illustrations/cylinder-thumb.svg',
  /** one small truck (SVG, ~1.5 KB, cached once) beside every Surat Jalan number: list rows, the note's header */
  truckThumb: '/illustrations/truck-thumb.svg',
  locations: '/illustrations/locations.webp',
  gateways: '/illustrations/gateways.webp',
  notFound: '/illustrations/not-found.webp',
  /** Log aktivitas: nothing yet (the depot scene until it has its own) */
  audit: '/illustrations/overview.webp',
  // the screen states, one scene each, the same on every screen (ui/States.tsx); not square: the component's box
  // keeps one footprint (object-fit: contain)
  stateError: '/illustrations/state-error.webp',
  stateOffline: '/illustrations/state-offline.webp',
  stateForbidden: '/illustrations/state-forbidden.webp',
  stateSessionExpired: '/illustrations/state-session-expired.webp',
  stateNoResults: '/illustrations/state-no-results.webp',
  stateSuccess: '/illustrations/state-success.webp',
  // the features' "nothing yet"
  households: '/illustrations/households.webp',
  orders: '/illustrations/orders.webp',
  hubApplications: '/illustrations/hub-applications.webp',
  visits: '/illustrations/visits.webp',
  deliveries: '/illustrations/deliveries.webp',
  verification: '/illustrations/verification.webp',
  counter: '/illustrations/counter.webp',
  alerts: '/illustrations/alerts.webp',
  users: '/illustrations/users.webp',
} as const;
export type IllustrationKey = keyof typeof ILLUSTRATIONS;

/**
 * The scene that stands for a location type where there is no photo (map panel, location header, list rows). Keys
 * are the API's location types; a hub (a village's small depot) uses the shop scene, an unknown type the plain one.
 */
const LOCATION_ILLUSTRATION: Record<string, string> = {
  OWNER_WAREHOUSE: '/illustrations/location-warehouse.webp',
  FILLING_STATION: '/illustrations/location-filling-station.webp',
  HUB: '/illustrations/location-outlet.webp',
  TEST_WORKSHOP: '/illustrations/location-test-workshop.webp',
};
const UNKNOWN_LOCATION = '/illustrations/location-other.webp';
export const locationIllustration = (type: string) => LOCATION_ILLUSTRATION[type] ?? UNKNOWN_LOCATION;
